/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistorySocialHistoryListAliases {
  BUTTON_ADD_HEALTH_HISTORY_SOCIAL_HISTORY = 'button-add-health-history-social-history',
  CONTEXTUAL_BAR_HEALTH_HISTORY_SOCIAL_HISTORY = 'contextual-bar-health-history-social-history',
  DECK_SOCIAL_HISTORY = 'deck-social-history',
  FETCH_SOCIAL_HISTORY_LIST = 'fetch-social-history-list',
  FILTERED_LIST_HEALTH_HISTORY_SOCIAL_HISTORY = 'filtered-list-health-history-social-history',
  GLOBAL_ACTIONS_HEALTH_HISTORY_SOCIAL_HISTORY = 'global-actions-health-history-social-history',
  HEALTH_HISTORY_CARD_SOCIAL_HISTORY = 'health-history-card-social-history',
  LAYOUT_HEALTH_HISTORY_SOCIAL_HISTORY_LIST = 'layout-health-history-social-history-list',
  LEGENDS_HEALTH_HISTORY_SOCIAL_HISTORY = 'legends-health-history-social-history',
  PANEL_SOCIAL_HISTORY_LIST = 'panel-social-history-list',
}
export { HealthHistorySocialHistoryListAliases };
